define(['angular'], function(angular) {


    function ClientProvider() {
        var bdcUrl;

        /**
         * @param {String} url
         */
        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                var self = {};

                /**
                 * Search a client
                 * @param  {String} search NIM or lastName
                 * @return {Promise}
                 */
                self.searchClient = function searchClient(search) {
                    return $http.get(bdcUrl + 'clients/search?search=' + search).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Create or update a client
                 * @param  {Object} data
                 * @return {Promise}
                 */
                self.createUpdate = function createUpdate(data) {
                    return $http.post(bdcUrl + 'client/createOrUpdate', data).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Download RFC clients by sectors
                 * @param  {String} sectors
                 * @return {Promise}
                 */
                self.downloadSectors = function downloadSectors(sectors) {
                    return $http.get(bdcUrl + 'clients/download/' + sectors).then(function(res) {
                        return res.data;
                    });
                };

                return self;
            }
        ];
    }

    angular.module('app.bdc.list.clientProvider', []).provider('client', ClientProvider);
});
